import { useEffect, useMemo, useState } from 'react'
import { socketGet } from '../socket'
import type { ResultFiles } from '../components'

export default function useMultipleFilesGrouping(items: any[], multipleFilesPopup: boolean) {
	const [resultFiles, setResultFiles] = useState<ResultFiles | null>(null)
	const socket = socketGet()

	useEffect(() => {
		const handlerResultFiles = (data: any) => {
			if (multipleFilesPopup && data.files && data.files.length > 1) {
				setResultFiles({
					filename: data.filename,
					files: data.files.map((f: any) => ({
						file: f.file,
						type: f.type,
						time: Math.floor(Date.now() / 1000),
						hash: f.hash,
					})),
				})
			}
		}

		if (socket) {
			socket.on('legacy_import_result_files', handlerResultFiles)

			return () => {
				socket.off('legacy_import_result_files', handlerResultFiles)
			}
		}
	}, [socket, multipleFilesPopup])

	const itemsByUniqueId = useMemo(() => {
		const map: Record<string, any[]> = {}
		if (!multipleFilesPopup) {
			return map
		}
		items.forEach((item: any) => {
			if (!item.unique_id) {
				return
			}
			if (!map[item.unique_id]) {
				map[item.unique_id] = []
			}
			map[item.unique_id].push(item)
		})
		return map
	}, [items, multipleFilesPopup])

	const getSiblings = (row: any) => {
		const group = itemsByUniqueId[row.unique_id] || []
		return group.filter((item: any) => item !== row)
	}

	const isPrimaryInGroup = (row: any) => {
		const group = itemsByUniqueId[row.unique_id] || []
		const summary = group.find((item: any) => item.rows === 'Failed' || item.rows.includes(' of '))
		if (summary) {
			return row === summary
		}
		return group.every((item: any) => item.time <= row.time)
	}

	const primaryItems = useMemo(() => {
		return items.filter((item: any) => isPrimaryInGroup(item))
	}, [items, itemsByUniqueId])

	const handleShowSiblings = (e: any) => {
		const siblings = getSiblings(e.row.data)
		setResultFiles({
			filename: e.row.data.file,
			files: siblings.map((item: any) => ({
				file: item.file,
				type: item.rows,
				time: item.time,
				hash: item.hash,
			})),
		})
	}

	return {
		primaryItems,
		getSiblings,
		handleShowSiblings,
		resultFiles,
		closeResultFiles: () => setResultFiles(null),
	}
}
